import { TApplicationState } from '../../types/redux';

export const selectFilters = (state: TApplicationState) => {
  return state.filters;
};
